import logo from '@/static/logo-green.jpg';

export default function Header() {
    return (
        <header className='bg-(--primary-soft) px-4 py-2 sticky top-0 z-50 border-b border-(--primary-border)'>
            <div className='flex items-center justify-between max-w-150 mx-auto'>
                <a
                    href="https://felicefashion.com/"
                    className='block h-13 w-13 overflow-hidden'
                >
                    <img
                        src={logo}
                        alt='Felice Fashion'
                        width={52}
                        height={52}
                        className='h-full w-full scale-125 object-contain mix-blend-multiply'
                    />
                </a>
                <span className='font-semibold tracking-wide text-(--primary)'>Felice Fashion</span>
            </div>
        </header>
    );
}
